//@flow

import React, { Component } from 'react';
import type { Node } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import { CardOverlayIcon as Icon } from '../../../constants/icons';
import type {
  TrekData,
  LodgeData,
  SightingData,
  SidetripData,
  AttractionData,
} from '../../../types/cards';
import { DesktopScreen } from '../../ResponsiveScreens';
import ImageWithBlur from '../../UI/ImageWithBlur';

type HGCardBaseProps = {
  children: Node,
  className: string,
  onClick?: Function,
  editable?: {
    isAdded: boolean,
    edit: ({
      cardData: TrekData | LodgeData | SightingData | SidetripData | AttractionData,
      message: string,
    }) => void,
    message: string,
    isLoading: boolean,
  },
  cardData: TrekData | LodgeData | SightingData | SidetripData | AttractionData | GuideData,
  url?: string,
  doesOpenInNewTab?: boolean,
  ribbon: string | null,
};

export default class HGCardBase extends Component<HGCardBaseProps> {
  static defaultProps = { ribbon: null };

  onEditPressed = async () => {
    const { editable, cardData } = this.props;
    await editable.edit({ cardData, message: editable.message });
  };

  render() {
    const { cardData, children, className, onClick, editable, url, ribbon } = this.props;
    const AnchorElement = url ? Link : 'a';

    return (
      <Card className={className}>
        <AnchorElement to={url ? url : ''} onClick={onClick}>
          <div
            className={`${
              editable ? (editable.isLoading ? 'btn-loading' : '') : ''
              } cardImage`}
          >
            <AnchorElement to={url ? url : ''} onClick={onClick}>
              {ribbon && <div className="ribbon">{ribbon}</div>}
              <ImageWithBlur
                images={cardData.cover_images}
                name={cardData.name ? cardData.name : cardData.fullname}
                // defaultImageURI={DEFAULT_IMAGE_URI}
                showImageType="large"
                timeoutBlur={2000}
              />
            </AnchorElement>
            <DesktopScreen>
              {editable && (
                <div className="overlayBtn">
                  <a className="btn btn-add" onClick={this.onEditPressed}>
                    <i className={editable.isAdded ? Icon.remove : Icon.add} />
                  </a>

                  <a className="btn btn-add" href={url ? url : null} onClick={onClick}>
                    <i className={Icon.view} />
                  </a>
                </div>
              )}
            </DesktopScreen>
          </div>
          <CardBody>{children}</CardBody>
        </AnchorElement>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cards/Common/HGCardBase.jsx